var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __decorateParam = (index, decorator) => (target, key) => decorator(target, key, index);

// db/MergingProxy.ts
import { Float } from "@adornis/baseql/baseqlTypes.js";
import { Arg, Entity, Subscription } from "@adornis/baseql/decorators.js";
import { AdornisEntity } from "@adornis/baseql/entities/adornisEntity.js";
import { migrateDuplicateIDToOriginalID } from "../server/migrateDuplicateIDToOriginalID.js";
var MergingProxy = class extends AdornisEntity {
  static migrateDuplicateIDToOriginalID(originalID, duplicateID, collectionName) {
    return () => {
      return migrateDuplicateIDToOriginalID(originalID, duplicateID, collectionName);
    };
  }
};
MergingProxy._class = "MergingProxy";
__decorateClass([
  Subscription((type) => Float),
  __decorateParam(0, Arg("originalID", (type) => String)),
  __decorateParam(1, Arg("duplicateID", (type) => String)),
  __decorateParam(2, Arg("collectionName", (type) => String))
], MergingProxy, "migrateDuplicateIDToOriginalID", 1);
MergingProxy = __decorateClass([
  Entity()
], MergingProxy);
export {
  MergingProxy
};
